import axios from "axios";

function NetworkSubscriptionMessageService() {
  return axios.get(process.env.REACT_APP_API_HOST + "/network_subscription_message", {
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
}

export default NetworkSubscriptionMessageService;
